import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { motion, AnimatePresence } from 'framer-motion'
import { flashMessageSelector } from 'apps/formsCreationKit/store/selectors/settings'
import { appSettingsActions } from 'apps/formsCreationKit/store/reducers/settings/appSettings'
const { updateFlashMessage } = appSettingsActions
import {
  ErrorIcon,
  SuccessIcon,
  WarningIcon,
  InfoIcon,
} from '@gocanvas/gcds/icons'

export const alertTypes = {
  error: 'alert--error',
  warning: 'alert--warning',
  success: 'alert--success',
  info: 'alert--info',
}

export const AlertIcons = {
  error: ErrorIcon,
  success: SuccessIcon,
  warning: WarningIcon,
  info: InfoIcon,
}

export const Alert = () => {
  const dispatch = useDispatch()
  const flashMessage = useSelector(flashMessageSelector) || {}
  const { type, message } = flashMessage
  const AlertIcon = AlertIcons[type] || null

  useEffect(() => {
    const reset = setTimeout(() => {
      flashMessage.type
        ? dispatch(
            updateFlashMessage({
              message: '',
              type: '',
            })
          )
        : ''
    }, 6000)

    return () => clearTimeout(reset)
  }, [flashMessage])

  return (
    <AnimatePresence initial={false}>
      {type && (
        <motion.div
          className={`studio--alert gcds--alert ${alertTypes[type]}`}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <div className="alert--icon">{AlertIcon && <AlertIcon />}</div>
          <div className="alert--message">{message}</div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
